module.exports = __webpack_public_path__ + "img/alianza-por-el-futuro.bca9995a.png";